var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('RenameOrgObject',{attrs:{"openDialog":_vm.value,"name":'Rename',"OrgObjectType":"Responsibility","placeholder":_vm.responsibility,"isShowCharCounter":true,"maxWidth":'430'},on:{"onAction":function($event){return _vm.$emit('onSave', $event)},"onClose":function($event){return _vm.$emit('input', false)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }